import { Injectable, signal } from '@angular/core';
import { FinishesSubStep } from '../models/finishes-sub-step.enum';

/**
 * Gère l'état de la sous-étape active dans l'étape Finitions.
 * Centralise la logique de navigation entre les cartes (Structure, Décors, Finitions)
 * pour éviter que le composant ne porte cet état localement.
 *
 * Ce service est fourni directement par {@link ClosetDoorsStandardFinishesComponent}
 * (via `providers: [FinishesSubStepService]`) : son cycle de vie est lié à celui du
 * composant et Angular le détruit automatiquement à la fermeture de l'étape.
 */
@Injectable()
export class FinishesSubStepService {
  private readonly _subStep = signal<FinishesSubStep>(FinishesSubStep.Doors);

  /** Sous-étape actuellement active en lecture seule. */
  readonly subStep = this._subStep.asReadonly();

  /**
   * Bascule la sous-étape demandée : l'ouvre si elle était fermée, la ferme si elle était déjà active.
   * @param step sous-étape à activer
   */
  toggle(step: FinishesSubStep): void {
    this._subStep.set(this._subStep() === step ? FinishesSubStep.None : step);
  }

  /**
   * Ferme toutes les cartes sans en ouvrir une autre.
   */
  close(): void {
    this._subStep.set(FinishesSubStep.None);
  }

}
